import { apiBaseAssets } from "../config/api";
import { useEffect, useState } from "react";
import lc from "../utils/language";
const useMediaQuery = (query) => {
  const [matches, setMatches] = useState(false);

  useEffect(() => {
    const media = window.matchMedia(query);
    if (media.matches !== matches) {
      setMatches(media.matches);
    }
    const listener = () => setMatches(media.matches);
    window.addEventListener("resize", listener);
    return () => window.removeEventListener("resize", listener);
  }, [matches, query]);

  return matches;
}
export const Header = ({ data, isRtl }) => {
  const [isVideo, setIsVideo] = useState(false);
  const isDesktop = useMediaQuery('(min-width: 991px)');

  useEffect(() => {
    if (data.background) {
      const ext = data.background.split(".")[1];

      if (ext === "mp4") setIsVideo(true);
      else setIsVideo(false);
    }
  }, [data]);
  return (
    <header
      id="header"
      style={{
        backgroundColor: "#081526",
      }}
    >
      <div
        className="intro"
        style={{
          background:
            data.background && !isVideo
              ? `url(${apiBaseAssets}${data.background}) center center no-repeat`
              : "none",
          backgroundSize: "cover",
        }}
      >
        {isVideo && (
          <video
            width={window.innerWidth}
            height={window.innerHeight}
            autoPlay={true}
            loop={true}
            muted={true}
            style={{
              width: "100%",
              height: "100vh",
              position: "absolute",
              backgroundColor: "#081526",
            }}
          >
            <source src={apiBaseAssets + data.background} type="video/mp4" />
          </video>
        )}
        <div
          className="overlay"
          style={{
            background: data.overlayColor ? data.overlayColor : "#081526",
            opacity: data.opacity ? data.opacity : "0.5",
            height: '100vh'
          }}
        >
          <div className="container">
            <div className="row">
              <div className="col-md-8 col-md-offset-2 intro-text" style={{ textAlign: 'start', paddingRight: isRtl ? isDesktop ? '90px' : '10px' : 0 }}>
                <h1
                  style={{ fontFamily: isRtl ? "amiriBold" : "Open Sans", color: '#fff', /*width: '516px',*/ }}
                  className="widthh1"
                >
                  {data.title ? data[lc("title", isRtl)] : "Loading"}
                  <span></span>
                </h1>
                <p
                  style={{
                    color: "#BDBDBD",
                    fontFamily: isRtl ? "amiriBold" : "Open Sans",
                  }}
                >
                  {data.subTitle ? data[lc("subTitle", isRtl)] : "Loading"}
                </p>
                <a
                  href="/more"
                  className="btn btn-custom btn-lg page-scroll"
                  style={{
                    display: 'flex', justifyContent: 'center', gap: '10px', fontFamily: isRtl ? "amiriBold" : "Open Sans",
                    background: 'linear-gradient(0.50turn, #2F80ED, #7FB6FF)', width: '290px', borderRadius: '12px', opacity: 1
                  }}
                >
                  <img style={{ width: '20px', height: '20px' }} src="img/Vector (2).png" />
                  {data.buttonTitle
                    ? data[lc("buttonTitle", isRtl)]
                    : "Learn more"}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};
